import jquery from 'jquery';

//вызов серверной функции
export function api(func, data){
    var result = '';

        jquery.ajax({
          type: "POST",
          url: "/api/api.php",
          async: false,
          data: {
            'func': func,
            'data': data
          },
          success: (res) => {
            result = res;
            console.log('api: '+func+' сработал');
          }
        })

        return result
}

export function fixedEncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
    return '%' + c.charCodeAt(0).toString(16);
  });
}



// WEBPACK FOOTER //
// ./src/extra.js